<template>
  <div v-if="loaderType.loading === true" id="app-loader" class="fixed f-center-column">
    <div class="spinner"></div>
    <p class="mt-4 font-center font-red" v-if="model.step === 3">
      {{ model.save.type === "SAVE" ? 'Prebieha odosielanie fotografií' : 'Prebieha ukladanie samoobhliadky' }}</p>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Loader',
  props: { loaderType: { required: false, type: Object, default: () => null } },
  computed: {
    ...mapGetters({
      model: 'getModel',
    }),
  },
}; </script>
<style lang="scss" scoped>
@import "~union_styles/scss/variables";
@import "~union_styles/scss/helpers/mixins/position";

$spinner-size: 200px;
#app-loader {
  z-index: 1000000;
  @include same-top-left(0);
  width: 100vw;
  height: 100vh;
  background-color: rgba($color-background, 0.80);

  .spinner {
    width: $spinner-size;
    height: $spinner-size;
    border-top: 3px solid $color-primary;
    border-right: 3px solid transparent;
    border-radius: 50%;
    animation: rotation 1.2s linear infinite;
  }
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
} </style>
